import { Button } from '@/shadcn-ui/button';
import { cn } from '@/shadcn-ui/utils';
import CreditAgeSummary from './credit-age-summary';
import PreviewYourRatesDrawerDialog, {
  PreviewYourRatesDrawerDialogProps,
} from './preview-your-rates-drawer-dialog';

export interface CreditAgeChangeDrawerDialogProps
  extends PreviewYourRatesDrawerDialogProps {
  handleOpen: () => void;
  className?: string;
  PRISTINE_HERO_PDP?: boolean;
}

export default function CreditAgeChangeDrawerDialog({
  open,
  handleOpen,
  handleClose,
  selectedCreditScoreId,
  selectedIsOver25,
  selectedAgeRangeId,
  creditScores,
  ageRanges,
  className,
  PRISTINE_HERO_PDP = false,
}: CreditAgeChangeDrawerDialogProps) {
  return (
    <>
      <Button
        type="button"
        variant="clear"
        className={cn('h-auto', className)}
        onClick={handleOpen}
      >
        <CreditAgeSummary
          selectedCreditScoreId={selectedCreditScoreId}
          selectedIsOver25={selectedIsOver25 ?? true}
          selectedAgeRangeId={selectedAgeRangeId}
          creditScores={creditScores}
          ageRanges={ageRanges}
          className="hover:cursor-pointer"
          PRISTINE_HERO_PDP={PRISTINE_HERO_PDP}
        />
      </Button>

      <PreviewYourRatesDrawerDialog
        selectedIsOver25={selectedIsOver25}
        selectedCreditScoreId={selectedCreditScoreId}
        creditScores={creditScores}
        ageRanges={ageRanges}
        selectedAgeRangeId={selectedAgeRangeId}
        open={open}
        handleClose={handleClose}
      />
    </>
  );
}
